import moment from "moment";

export function getDatesDifferenceInDays(startDate: Date | null, endDate: Date | null): string | null {
    if (!startDate || !endDate) {
        return null;
    }

    const duration = moment.duration(moment(endDate).diff(moment(startDate)));
    const n = 24 * 60 * 60 * 1000;
    const days = Math.floor(duration.asMilliseconds() / n);
    const str = moment.utc(duration.asMilliseconds() % n).format("H [h] mm [m] ss [s]");

    return `${days > 0 ? `${days} ${days === 1 ? "d" : "d(s)"} ` : ""}${str}`;
}
